import connectManagerClient from '@/lib/connect-client/connect-manager-client'
import connectPayClient from '@/lib/connect-client/connect-pay-client'
import store from '../index'
import * as Types from '../mutation-types'
import PurchaseInfo from '@/lib/purchase-info'
import storage from '@/lib/storage'

const state = {
  stripeInfo: undefined,
  billingPlans: [],
  purchaseInfo: {},
  invoices: [],
  invoiceUpcoming: {},
  coupons: [],
}

const getters = {
  stripeInfo: state => state.stripeInfo,
  billingPlans: state => state.billingPlans,
  purchaseInfo: function(state) {
    if (state.purchaseInfo) {
      return state.purchaseInfo
    }
    return storage.getPurchaseInfo()
  },
  invoices: state => state.invoices,
  invoiceUpcoming: state => state.invoiceUpcoming,
  coupons: state => state.coupons,
}

const mutations = {
  [Types.SET_STRIPE_INFO](state, stripeInfo) {
    state.stripeInfo = stripeInfo
  },
  [Types.SET_BILLING_PLANS](state, billingPlans) {
    state.billingPlans = billingPlans
  },
  [Types.SET_PURCHASE_INFO](state, purchaseInfo) {
    state.purchaseInfo = purchaseInfo
  },
  [Types.SET_INVIOCES](state, invoices) {
    state.invoices = invoices
  },
  [Types.SET_INVIOCE_UPCOMING](state, invoiceUpcoming) {
    state.invoiceUpcoming = invoiceUpcoming
  },
  [Types.SET_LIST_COUPON](state, coupons) {
    state.coupons = coupons
  },
}

const actions = {
  setPurchaseInfoFromUserInfo({ commit }, userInfo) {
    if (userInfo.purchaseInfo) {
      commit(Types.SET_PURCHASE_INFO, new PurchaseInfo(userInfo.purchaseInfo))
    }
  },

  getStripeInfo({ commit }, params) {
    connectPayClient
      .getStripeInfo()
      .then(response => {
        commit(Types.SET_STRIPE_INFO, response.data)
        if (params) {
          if (params.onSuccess) {
            params.onSuccess()
          }
        }
      })
      .catch(error => {
        console.error(error.response)
      })
  },

  addStripeCreditCard({ commit }, params) {
    connectPayClient
      .addStripeCreditCard(params)
      .then(response => {
        params.onSuccess()
        store.dispatch('getStripeInfo')
      })
      .catch(error => {
        params.onFailure(error.response)
      })
  },

  deleteStripeCreditCard({ commit }, params) {
    connectPayClient
      .deleteStripeCreditCard(params)
      .then(response => {
        store.dispatch('getStripeInfo')
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure(error.response)
      })
  },

  selectStripeCreditCard({ commit }, params) {
    connectPayClient
      .selectStripeCreditCard(params)
      .then(response => {
        params.onSuccess()
        store.dispatch('getStripeInfo')
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },

  listBillingPlans({ commit }, params = {}) {
    connectPayClient
      .listBillingPlans()
      .then(response => {
        const plans = response.data
        if (plans) {
          commit(Types.SET_BILLING_PLANS, plans)
          if (params.onSuccess) {
            params.onSuccess()
          }
        }
      })
      .catch(error => {
        console.error(error.response)
      })
  },

  // Deplicated APIもDeplicatedなので移行しない
  subscribeStripePlanWithDiscount({ commit }, params) {
    connectManagerClient
      .subscribeStripePlanWithDiscount(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },

  subscribeStripePlan({ commit }, params) {
    connectPayClient
      .subscribeStripePlan(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },

  changePaymentMethodTypes({ commit }, params) {
    connectPayClient
      .changePaymentMethodTypes(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },

  unsubscribeStripeSubscription({ commit }, params) {
    connectPayClient
      .unsubscribeStripe(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },

  // Deplicated APIもDeplicatedなので移行しない
  getInvoices({ commit }, params) {
    connectManagerClient
      .getInvoices()
      .then(response => {
        const invoices = response.data
        if (invoices) {
          commit(Types.SET_INVIOCES, invoices)
        }
      })
      .catch(error => {
        console.error(error.response)
      })
  },

  // Deplicated APIもDeplicatedなので移行しない
  getInvoicesUpcoming({ commit }, params) {
    connectManagerClient
      .getInvoicesUpcoming()
      .then(response => {
        const invoiceUpcoming = response.data
        if (invoiceUpcoming) {
          commit(Types.SET_INVIOCE_UPCOMING, invoiceUpcoming)
        }
      })
      .catch(error => {
        console.error(error)
      })
  },
  changeStripePlan({ commit }, params) {
    connectPayClient
      .changeStripePlan(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        params.onFailure()
        console.error(error.response)
      })
  },
  listStripeCoupons({ commit }) {
    connectPayClient
      .listStripeCoupons()
      .then(response => {
        commit(Types.SET_LIST_COUPON, response.data)
      })
      .catch(error => {
        console.error(error.response)
      })
  },

  getPurchaseInfo({ commit }, params = {}) {
    connectPayClient
      .getPurchaseInfo()
      .then(response => {
        const purchaseInfo = response.data
        commit(Types.SET_PURCHASE_INFO, purchaseInfo)
        storage.savePurchaseInfo(purchaseInfo)
        if (params.onSuccess) {
          params.onSuccess()
        }
      })
      .catch(error => {
        console.error(error.response)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
